import MagstimTable from './MagstimTable';
import { CurrentLang } from "common";
import { convertVersionProperty } from '../../utils/ConvertVersionPropertyUtils'

class MagstimTableDeviceTraceability extends MagstimTable {


	initForSelect = (data, visibleColumns) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data, visibleColumns), undefined);
	}

	configTableData(data, visibleColumns) {

		//console.log(data);

		var retVal = {
            showSelectAtStart:true,
			columns: [
			],
			data: data
		};
		
		retVal.columns.push({ title: convertVersionProperty("Name"), property: 'Name', isSearchable:true, isHidden: false });
		retVal.columns.push({ title: CurrentLang().settings_windows_sn, property: 'PcSerialNumber', isSearchable:true, isHidden: false });
        retVal.columns.push({ title: CurrentLang().organisation, property: 'OrganisationName', isSearchable:true, isHidden: false });
        this.addColumn(retVal.columns, visibleColumns, 'ApplicationSoftware', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'ProcessMonitorSoftware', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'PlatformSoftware', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'WindowsUpdateVersion', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'StimGuideVersion', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'HardwareNumber', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'RevisionNumber', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'SoftwareNumber', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'VersionNumber', undefined)
        this.addColumn(retVal.columns, visibleColumns, 'HciStatusRes', this.formatTranslated)
        this.addColumn(retVal.columns, visibleColumns, 'EpvStatusRes', this.formatTranslated)
        this.addColumn(retVal.columns, visibleColumns, 'ServiceStatusRes', this.formatTranslated)

		return retVal;
	}

    addColumn(columns, visibleColumns, propertyName, formatter){
        const isHidden = this.getIsHidden(visibleColumns, propertyName);
        columns.push({ title: convertVersionProperty(propertyName), property: propertyName, isSearchable:false, isHidden: isHidden, formatter: formatter });
    }

    getIsHidden(visibleColumns, property){
        return visibleColumns.filter(o => o === property).length === 0;
    }


	resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
	}

}

export default MagstimTableDeviceTraceability;